// Google Identity Services keeps only the callback of the last initialize() call, so every instance
// registers its sender here and GSI always talks to the latest one, however the mounts and inits interleave.
let currentCredentialSender = null

const handleCredentialResponse = (response) => {
  currentCredentialSender?.(response.credential)
}

App.namespace.wrap('es6.shared.google_login_manager', function (options = {}) {
  const {
    buttonId,
    googleUrl,
    googleClientId,
    csrfToken,
    callback,
    onError,
    prompt,
    autoLoginOnClick,
    trackingParams = {},
  } = options

  const GOOGLE_API_URL = 'https://accounts.google.com/gsi/client'
  const LOGIN_CONTAINER_ID = '#login-with-google-container'
  const GENERIC_ERROR_MESSAGE = 'There was an error trying to login with Google, please try again'

  const api = {
    triggerModal() {
      $(LOGIN_CONTAINER_ID).find('[role="button"]').click();
    },
  }

  const sendAjaxRequest = (token) => {
    $.ajax({
      method: "POST",
      url: googleUrl,
      data: {
        idtoken: token,
        _token: csrfToken,
        trackingParams: typeof trackingParams === 'function' ? trackingParams() : trackingParams,
      },
      contentType: 'application/x-www-form-urlencoded',
      success: (response) => {
        if(typeof callback === 'function') {
          callback(response, token);
        } else if(typeof window[callback] === 'function') {
          window[callback](response, token);
        }
      },
      error: (jqXHR) => {
        const socialLoginError = App.es6.shared.social_login_error;
        const refusalMessage = socialLoginError.getRefusalMessage(jqXHR);

        if (!refusalMessage) {
          Rollbar.critical('Failed google login attempt');
        }

        const message = refusalMessage || GENERIC_ERROR_MESSAGE;

        if (typeof onError === 'function') {
          onError(message);
          return;
        }

        socialLoginError.show(message);
      }
    });
  }

  const bindBtnClick = () => {
    const loginNode = document.querySelector(LOGIN_CONTAINER_ID);
    currentCredentialSender = sendAjaxRequest;
    window.google.accounts.id.initialize({
      client_id: googleClientId,
      ux_mode: 'popup',
      text: 'Log in with Google',
      callback: handleCredentialResponse,
    });

    window.google.accounts.id.renderButton(
      loginNode,
      {
        callback: handleCredentialResponse,
      },
    );

    if (autoLoginOnClick) {
      document.getElementById(buttonId).addEventListener('click', () => {
        api.triggerModal();
      });
    }

    if (prompt) {
      window.google.accounts.id.prompt();
    }
  };

  const waitForGoogleAPI = (initCallback) => {
    App.es6.shared.waitFor(() => {
      return window.google && window.google.accounts;
    }, error => {
      if (error) {
        window._GAPi_ERROR = 'Couldn\'t load google api.';
        initCallback();
        return;
      }
      bindBtnClick(initCallback);
    }, {attempts: 20});
  };

  const noop = () => null;
  const init = (initCallback = noop) => {
    if (window.google?.accounts?.id) {
      waitForGoogleAPI(initCallback);
    } else {
      $.getScript(GOOGLE_API_URL)
        .done(() => waitForGoogleAPI(initCallback));
    }

    return api;
  };

  return {
    init
  }
});
